import { CORE_PHYSICS } from "../../config/gameplay";
import { isAngleInPolarityWindow } from "../arena/shells";
import type { CoreState, ShellState, Vector2 } from "../runtime/types";
import type { UpgradeEffects } from "../upgrades/effects";

export interface PolarityMatchResult {
  readonly coreId: number;
  readonly shellIndex: number;
  readonly color: CoreState["color"];
  readonly stack: number;
  readonly stackCap: number;
  readonly charge: number;
  readonly position: Vector2;
  readonly strong: boolean;
}

export function calculatePolarityCharge(stacks: number, effects: UpgradeEffects): number {
  const baseCharge = Math.min(1.85, stacks * effects.polarityChargePerStack);
  return Math.min(effects.polarityChargeMax, baseCharge * effects.polarityPrestigeMultiplier);
}

export function tryApplyPolarityMatch(
  core: CoreState,
  shell: ShellState,
  angleDegrees: number,
  effects: UpgradeEffects,
  position: Vector2
): PolarityMatchResult | null {
  if (
    !effects.polarityEnabled ||
    core.polarityCooldownSeconds > 0 ||
    core.polarityStacks >= effects.polarityStackCap ||
    !isAngleInPolarityWindow(shell, angleDegrees, core.color)
  ) {
    return null;
  }

  core.polarityStacks += 1;
  core.polarityCharge = calculatePolarityCharge(core.polarityStacks, effects);
  core.polarityCooldownSeconds = CORE_PHYSICS.polarityCooldownSeconds;

  return {
    coreId: core.id,
    shellIndex: shell.index,
    color: core.color,
    stack: core.polarityStacks,
    stackCap: effects.polarityStackCap,
    charge: core.polarityCharge,
    position: { ...position },
    strong: core.polarityStacks % 4 === 0 || core.polarityStacks >= effects.polarityStackCap
  };
}
